import React from 'react';
import Slider from 'react-slick';
import Testimonialimg01 from '../../../assets/images/testimonial/testimonial-three-qute.svg';
import Testimonialimg02 from '../../../assets/images/testimonial/testimonial-five.png';
import Testimonialimg03 from '../../../assets/images/process/process-five-1.png';
import Testimonialimg04 from '../../../assets/images/process/process-five-3.png';
import PreImage from '../../../assets/images/testimonial/testimonial-five-pre.svg';
import NextImage from '../../../assets/images/testimonial/testimonial-five-next.svg';

const testimonials = [
    {
        id: 1,
        icon: Testimonialimg01,
        quote: "Vulputate mi sit amet mauris commodo quis imperdiet. Metus vulputate eu felis imperdiet proin nulla aliquet enim.",
        image: Testimonialimg02,
        name: "John Doue",
        position: "Digital marketing"
    },
    {
        id: 2,
        icon: Testimonialimg01, 
        quote: "Vulputate mi sit amet mauris commodo quis imperdiet. Metus vulputate eu felis imperdiet proin nulla aliquet enim.",
        image: Testimonialimg03,
        name: "Alex Peterson",
        position: "Content Strategist"
    },
    {
        id: 3,
        icon: Testimonialimg01,
        quote: "Vulputate mi sit amet mauris commodo quis imperdiet. Metus vulputate eu felis imperdiet proin nulla aliquet enim.",
        image: Testimonialimg04,
        name: "Mark Johnson",
        position: "Social Media Campaigns"
    }
];

const Testimonial = () => {
    const TestimonialSlider = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: (
            <button type="button" className="slick-prev">
                <img src={PreImage} alt="Previous" />
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next">
                <img src={NextImage} alt="Next" />
            </button>
        ),

    };
    return (
        <>
            <div className="testimonial-section-five">
                <div className="container">
                    <Slider className="testimonial-slider-five" {...TestimonialSlider}>
                        {testimonials.map((testimonial) => (
                            <div key ={testimonial.id} className="testimonial-item-five">
                                <div className="testimonial-box-five">
                                    <div className="testimonial-icon-five">
                                        <img
                                            src={testimonial.icon}
                                            alt="testimonial-icon"
                                        />
                                    </div>
                                    <p>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus vulputate
                                        eu felis imperdiet proin nulla aliquet enim.
                                    </p>
                                    <img
                                        src={testimonial.image}
                                        alt="testimonial-image"
                                    />
                                    <div className="testimonial-details-five">
                                        <h4>{testimonial.name}</h4>
                                        <span>{testimonial.position}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </>
    )
}

export default Testimonial;
